const zIndex = {
  featuredPostCarousel: 1,
  navOverlay: 5,
  nav: 6,
  fullScreenVideo: 10,
};

export default zIndex;
